import { render, staticRenderFns } from "./Membersettings.vue?vue&type=template&id=defe0558&scoped=true"
import script from "./Membersettings.vue?vue&type=script&lang=js"
export * from "./Membersettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defe0558",
  null
  
)

export default component.exports